import admiral from './admiral.png'
import aetna from './aetna.png'
import allstate from './allstate.png'
import americancollectors from './americancollectors.png'
import americanmodern from './americanmodern.png'
import americanreliable from './americanreliable.png'
import ameritas from './ameritas.png'
import appliedunderwriters from './appliedunderwriters.png'
import arch from './arch.png'
import brighthouse from './brighthouse.png'
import bristolwest from './bristolwest.png'
import cdphp from './cdphp.png'
import chautauquapatrons from './chautauquapatrons.png'
import cherryvalley from './cherryvalley.png'
import chubb from './chubb.png'
import cigna from './cigna.png'
import condonskelly from './condonskelly.png'
import countryway from './countryway.png'
import drydenmutual from './drydenmutual.png'
import encompass from './encompass.png'
import equitable from './equitable.png'
import erieandniagara from './erieandniagara.png'
import esip from './esip.png'
import excellus from './excellus.png'
import farmfamily from './farmfamily.png'
import fema from './fema.png'
import fidelis from './fidelis.png'
import foremost from './foremost.png'
import gerber from './gerber.png'
import globalaerospace from './globalaerospace.png'
import globelife from './globelife.png'
import greatamerican from './greatamerican.png'
import grundy from './grundy.png'
import guard from './guard.png'
import guardianlife from './guardian.png'
import hagerty from './hagerty.png'
import hanover from './hanover.png'
import highmark from './highmark.png'
import hudson from './hudson.png'
import humana from './humana.png'
import jctaylor from './jctaylor.png'
import lancer from './lancer.png'
import libertymutual from './libertymutual.png'
import mainstreetamerica from './mainstreetamerica.png'
import markel from './markel.png'
import mcneil from './mcneil.png'
import merchants from './merchants.png'
import metlife from './metlife.png'
import molina from './molina.png'
import mutualofomaha from './mutualofomaha.png'
import mvp from './mvp.png'
import nationalgeneral from './nationalgeneral.png'
import nationwide from './nationwide.png'
import nautilus from './nautilus.png'
import newyorkcentralmutual from './newyorkcentralmutual.png'
import newyorkstateinsurancefund from './newyorkstateinsurancefund.png'
import omahanational from './omahanational.png'
import ontario from './ontario.png'
import philadelphia from './philadelphia.png'
import preferredmutual from './preferredmutual.png'
import principal from './principal.png'
import progressive from './progressive.png'
import rli from './rli.png'
import royalarcanum from './royalarcanum.png'
import safeco from './safeco.png'
import sbli from './sbli.png'
import scottsdale from './scottsdale.png'
import securitycooperative from './securitycooperative.png'
import securitymutual from './securitymutual.png'
import selective from './selective.png'
import shelterpoint from './shelterpoint.png'
import silverscript from './silverscript.png'
import sterling from './sterling.png'
import thehartford from './thehartford.png'
import travelers from './travelers.png'
import unitedfrontier from './unitedfrontier.png'
import unitedhealthcare from './unitedhealthcare.png'
import univera from './univera.png'
import usli from './usli.png'
import uticafirst from './uticafirst.png'
import uticanational from './uticanational.png'
import vsp from './vsp.png'
import waynecooperative from './waynecooperative.png'
import wellcare from './wellcare.png'
import williampenn from './williampenn.png'
import williampennassociation from './williampennassociation.png'

export const logos = [
	{
		name: 'Admiral Insurance Group',
		pagePath: 'admiral-insurance-group',
		src: admiral,
	},
	{
		name: 'Aetna',
		pagePath: 'aetna',
		src: aetna,
	},
	{
		name: 'Allstate',
		pagePath: 'allstate',
		src: allstate,
	},
	{
		name: 'American Collectors Insurance',
		pagePath: 'american-collectors-insurance',
		src: americancollectors,
	},
	{
		name: 'American Modern Insurance Group',
		pagePath: 'american-modern-insurance-group',
		src: americanmodern,
	},
	{
		name: 'American Reliable Insurance Company',
		pagePath: 'american-reliable-insurance-company',
		src: americanreliable,
	},
	{
		name: 'Ameritas Insurance Company',
		pagePath: 'ameritas-insurance-company',
		src: ameritas,
	},
	{
		name: 'Applied Underwriters',
		pagePath: 'applied-underwriters',
		src: appliedunderwriters,
	},
	{
		name: 'Arch Insurance Group',
		pagePath: 'arch-insurance-group',
		src: arch,
	},
	{
		name: 'Brighthouse',
		pagePath: 'brighthouse-financial',
		src: brighthouse,
	},
	{
		name: 'Bristol West Insurance Group',
		pagePath: 'bristol-west-insurance-group',
		src: bristolwest,
	},
	{
		name: 'CDPHP',
		pagePath: 'cdphp',
		src: cdphp,
	},
	{
		name: 'Chautauqua Patrons Insurance Company',
		pagePath: 'chautauqua-patrons-insurance-company',
		src: chautauquapatrons,
	},
	{
		name: 'Cherry Valley Cooperative',
		pagePath: 'cherry-valley-cooperative',
		src: cherryvalley,
	},
	{
		name: 'Chubb',
		pagePath: 'chubb',
		src: chubb,
	},
	{
		name: 'Cigna',
		pagePath: 'cigna',
		src: cigna,
	},
	{
		name: 'Condon & Skelly',
		pagePath: 'condon-and-skelly',
		src: condonskelly,
	},
	{
		name: 'Countryway Insurance Company',
		pagePath: 'countryway-insurance-company',
		src: countryway,
	},
	{
		name: 'Dryden Mutual Insurance Company',
		pagePath: 'dryden-mutual-insurance-company',
		src: drydenmutual,
	},
	{
		name: 'Encompass',
		pagePath: 'encompass',
		src: encompass,
	},
	{
		name: 'Equitable',
		pagePath: 'equitable',
		src: equitable,
	},
	{
		name: 'Erie and Niagara Insurance Association',
		pagePath: 'erie-and-niagara-insurance-association',
		src: erieandniagara,
	},
	{
		name: 'ESIP',
		pagePath: 'esip',
		src: esip,
	},
	{
		name: 'Excellus',
		pagePath: 'excellus',
		src: excellus,
	},
	{
		name: 'Farm Family',
		pagePath: 'farm-family',
		src: farmfamily,
	},
	{
		name: 'FEMA',
		pagePath: 'fema',
		src: fema,
	},
	{
		name: 'Fidelis Care',
		pagePath: 'fidelis-care',
		src: fidelis,
	},
	{
		name: 'Foremost Insurance Group',
		pagePath: 'foremost-insurance-group',
		src: foremost,
	},
	{
		name: 'Gerber Life Insurance Company',
		pagePath: 'gerber-life-insurance-company',
		src: gerber,
	},
	{
		name: 'Global Aerospace',
		pagePath: 'global-aerospace',
		src: globalaerospace,
	},
	{
		name: 'Globe Life',
		pagePath: 'globe-life',
		src: globelife,
	},
	{
		name: 'Great American Insurance Group',
		pagePath: 'great-american-insurance-group',
		src: greatamerican,
	},
	{
		name: 'Grundy Worldwide',
		pagePath: 'grundy-worldwide',
		src: grundy,
	},
	{
		name: 'Guard Insurance Group',
		pagePath: 'guard-insurance-group',
		src: guard,
	},
	{
		name: 'Guardian Life Insurance Company',
		pagePath: 'guardian-life-insurance-company',
		src: guardianlife,
	},
	{
		name: 'Hagerty',
		pagePath: 'hagerty',
		src: hagerty,
	},
	{
		name: 'Hanover Insurance Group',
		pagePath: 'hanover-insurance-group',
		src: hanover,
	},
	{
		name: 'Highmark',
		pagePath: 'highmark',
		src: highmark,
	},
	{
		name: 'Hudson Insurance Group',
		pagePath: 'hudson-insurance-group',
		src: hudson,
	},
	{
		name: 'Humana',
		pagePath: 'humana',
		src: humana,
	},
	{
		name: 'JC Taylor',
		pagePath: 'jc-taylor',
		src: jctaylor,
	},
	{ name: 'Lancer', pagePath: 'lancer', src: lancer },
	{
		name: 'Liberty Mutual',
		pagePath: 'liberty-mutual',
		src: libertymutual,
	},
	{
		name: 'Main Street America Group',
		pagePath: 'main-street-america-group',
		src: mainstreetamerica,
	},
	{
		name: 'Markel Insurance Company',
		pagePath: 'markel-insurance-company',
		src: markel,
	},
	{
		name: 'McNeil & Company',
		pagePath: 'mcneil-and-company',
		src: mcneil,
	},
	{
		name: 'Merchants Insurance Group',
		pagePath: 'merchants-insurance-group',
		src: merchants,
	},
	{ name: 'MetLife', pagePath: 'metlife', src: metlife },
	{
		name: 'Molina Healthcare',
		pagePath: 'molina-healthcare',
		src: molina,
	},
	{
		name: 'Mutual of Omaha',
		pagePath: 'mutual-of-omaha',
		src: mutualofomaha,
	},
	{
		name: 'MVP Healthcare',
		pagePath: 'mvp-healthcare',
		src: mvp,
	},
	{
		name: 'National General Insurance',
		pagePath: 'national-general-insurance',
		src: nationalgeneral,
	},
	{ name: 'Nationwide', pagePath: 'nationwide', src: nationwide },
	{
		name: 'Nautilus Insurance Group',
		pagePath: 'nautilus-insurance-group',
		src: nautilus,
	},
	{
		name: 'New York Central Mutual',
		pagePath: 'new-york-central-mutual',
		src: newyorkcentralmutual,
	},
	{
		name: 'New York State Insurance Fund',
		pagePath: 'new-york-state-insurance-fund',
		src: newyorkstateinsurancefund,
	},
	{
		name: 'Omaha National',
		pagePath: 'omaha-national',
		src: omahanational,
	},
	{
		name: 'Ontario Insurance Company',
		pagePath: 'ontario-insurance-company',
		src: ontario,
	},
	{
		name: 'Philadelphia Insurance Companies',
		pagePath: 'philadelphia-insurance-companies',
		src: philadelphia,
	},
	{
		name: 'Preferred Mutual Insurance Company',
		pagePath: 'preferred-mutual-insurance-company',
		src: preferredmutual,
	},
	{
		name: 'Principal Financial Group',
		pagePath: 'principal-financial-group',
		src: principal,
	},
	{
		name: 'Progressive',
		pagePath: 'progressive',
		src: progressive,
	},
	{
		name: 'RLI',
		pagePath: 'rli',
		src: rli,
	},
	{
		name: 'Royal Arcanum',
		pagePath: 'royal-arcanum',
		src: royalarcanum,
	},
	{
		name: 'Safeco',
		pagePath: 'safeco',
		src: safeco,
	},
	{
		name: 'SBLI Insurance Company',
		pagePath: 'sbli-insurance-company',
		src: sbli,
	},
	{
		name: 'Scottsdale Insurance Company',
		pagePath: 'scottsdale-insurance-company',
		src: scottsdale,
	},
	{
		name: 'Security Cooperative Insurance Company',
		pagePath: 'security-cooperative-insurance-company',
		src: securitycooperative,
	},
	{
		name: 'Security Mutual Insurance Company',
		pagePath: 'security-mutual-insurance-company',
		src: securitymutual,
	},
	{
		name: 'Selective Insurance Group',
		pagePath: 'selective-insurance-group',
		src: selective,
	},
	{
		name: 'ShelterPoint',
		pagePath: 'shelterpoint',
		src: shelterpoint,
	},
	{
		name: 'Silverscript',
		pagePath: 'silverscript',
		src: silverscript,
	},
	{
		name: 'Sterling Insurance Company',
		pagePath: 'sterling-insurance-company',
		src: sterling,
	},
	{
		name: 'The Hartford',
		pagePath: 'the-hartford',
		src: thehartford,
	},
	{
		name: 'Travelers',
		pagePath: 'travelers',
		src: travelers,
	},
	{
		name: 'United Frontier Mutual Insurance Company',
		pagePath: 'united-frontier-mutual-insurance-company',
		src: unitedfrontier,
	},
	{
		name: 'UnitedHealthcare',
		pagePath: 'unitedhealthcare',
		src: unitedhealthcare,
	},
	{
		name: 'United States Liability Insurance Group',
		pagePath: 'united-states-liability-insurance-group',
		src: usli,
	},
	{
		name: 'Univera Healthcare',
		pagePath: 'univera-healthcare',
		src: univera,
	},
	{
		name: 'Utica First Insurance Company',
		pagePath: 'utica-first-insurance-company',
		src: uticafirst,
	},
	{
		name: 'Utica National Insurance Group',
		pagePath: 'utica-national-insurance-group',
		src: uticanational,
	},
	{
		name: 'VSP',
		pagePath: 'vsp',
		src: vsp,
	},
	{
		name: 'Wayne Cooperative Insurance Company',
		pagePath: 'wayne-cooperative-insurance-company',
		src: waynecooperative,
	},
	{
		name: 'Wellcare',
		pagePath: 'wellcare',
		src: wellcare,
	},
	{
		name: 'William Penn',
		pagePath: 'william-penn',
		src: williampenn,
	},
	{
		name: 'William Penn Association',
		pagePath: 'william-penn-association',
		src: williampennassociation,
	},
]
